import { ArrowRight, Sms } from "iconsax-react";
import InputField, {
  DEAInput,
  NPIInput,
} from "../../components/inputs/InputField";
import PasswordField from "../../components/inputs/PasswordField";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import NormalInputField from "../../components/inputs/NormalInputField";
import NormalSelectInputField from "../../components/inputs/NormalSelectInputField";
import SignatureCanvas from "react-signature-canvas";
import { useEffect, useRef, useState } from "react";
import instance from "../../axios/instance";
import Spinner from "../../components/spinners/Spinner";
import AuthButton from "../../components/buttons/AuthButton";
import { saveToken } from "../../utils/token";
import countries from "../../../countries.json";
import { toast } from "react-toastify";
import { AgreementConsent } from "../../components/AgreementConsent";

// TODO: update token when doctor updates personal information
export default function RegisterPage() {
  const navigate = useNavigate();
  const [searchParams, setParams] = useSearchParams();
  const token = searchParams.get("token");
  const type = searchParams.get("type");
  const [doctor, setDoctor] = useState(null);
  const signatureRef = useRef();

  function clearSignature() {
    signatureRef.current.clear();
  }

  // form inputs
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [prefix, setPrefix] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [degree, setDegree] = useState("");
  const [specialization, setSpecialization] = useState("");

  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [homePhone, setHomePhone] = useState("");
  const [workPhone, setWorkPhone] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");

  const [licenseNumber, setLicenseNumber] = useState("");
  const [deaNumber, setDeaNumber] = useState("");
  const [npiNumber, setNpiNumber] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [facility, setFacility] = useState(null);

  // loading state
  const [isLoading, setIsLoading] = useState(false);
  const [defLoading, setDefLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [code, setCode] = useState("");

  const getStates = () => {
    if (country) {
      const _country = countries.find(
        (_country) => _country.name.toLowerCase() === country.toLowerCase()
      );
      return _country ? _country.states.map((state) => state.name) : [];
    }
    return [];
  };

  // check if button should be active using required fields
  const isButtonNotActive =
    !firstname ||
    !lastname ||
    !prefix ||
    !gender ||
    !dob ||
    !degree ||
    !specialization ||
    !address1 ||
    !homePhone ||
    !workPhone ||
    !country ||
    !state ||
    !city ||
    !zipcode ||
    !email ||
    !password;

  // error state
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let subscribed = true;
    if (token) {
      setDefLoading(true);
      (async () => {
        try {
          const res = await instance.get("/doctor/facility", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (subscribed) {
            setEmail(res.data.email);
            setFacility(res.data);
            setDefLoading(false);
          }
        } catch (e) {
          console.log('ERROR')
          console.log(e, subscribed);
          subscribed && setDefLoading(false);
        }
      })();
    } else {
      setDefLoading(false);
    }

    return () => {
      subscribed = false;
    };
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (signatureRef.current.isEmpty()) {
      // checks if signature is active
      setErrorMessage("Signature is required");
      setIsLoading(false);
    } else {
      try {
        await instance.post(
          "/doctor/auth/verify-facility-email",
          { email },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        setSuccess(true);
        localStorage.setItem(
          "signature",
          JSON.stringify(signatureRef.current.toData())
        );
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setErrorMessage(error.response?.data.message);
        setIsLoading(false);
      }
    }
  };

  async function registerDoctor() {
    // also we would be verifyng dea with formula here in front end
    setErrorMessage("");
    setIsLoading(true);
    instance
      .post(
        "/doctor/auth/register",
        {
          firstname: firstname,
          lastname: lastname,
          prefix: prefix,
          gender: gender,
          dob: new Date(dob).toLocaleString(),
          npi_number: npiNumber,
          degree: degree,
          specialization: specialization,
          address1: address1,
          address2: address2,
          home_phone: homePhone,
          work_phone: workPhone,
          country: country,
          state: state,
          city: city,
          zipcode: zipcode,
          license_number: licenseNumber,
          dea_number: deaNumber,
          signature: localStorage.getItem("signature"),
          email: email,
          password: password,
          facility_id: facility?.id,
          code,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        // store token in session storage then redirect to dashboard
        saveToken(res.data.ACCESS_TOKEN);
        toast.success("Account created successfully");
        localStorage.removeItem("signature");
        navigate("/dashboard/overview");
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      });
  }

  const isAccessible = !defLoading && facility?.id;
  const isBtnNotActive = code.length < 6;

  return success ? (
    <div className="h-[100vh] bg-[#f1f1f1] flex flex-col justify-center items-center">
      <div className="bg-white flex flex-col justify-center items-center py-12 px-10 shadow-lg rounded-[10px]">
        <img src="/clinic/images/logo1.png" className="w-48 mb-2" />
        <div className="text-gray-500">Verify your email.</div>
        <div className="text-gray-500 mt-2 text-center">
          A 6 digit code was sent to your email address. <br />
          Enter code below
        </div>
        <form
          onSubmit={registerDoctor}
          className="mt-8 space-y-4 flex flex-col"
        >
          <InputField
            icon={<Sms size={16} variant="Bold" />}
            type="text"
            placeholder="Enter code"
            onChange={(e) => setCode(e.target.value)}
          />

          <AuthButton
            title="Submit"
            disabled={isBtnNotActive || isLoading}
            isLoading={isLoading}
            type="submit"
            onClick={registerDoctor}
          />

          <div className="font-semibold text-red-500">{errorMessage}</div>
        </form>
      </div>
    </div>
  ) : (
    <div className="bg-white text-[14px]">
      <div className="p-4 bg-[#f1f1f1]">
        <img src="/clinic/images/logo1.png" className="w-40 mb-4" />
        <div className="flex justify-between items-end">
          <div>
            <div className="text-[18px] font-bold mb-1">Sign up</div>
            <div className="text-gray-500 text-[14px]">
              Fill in your credentials to set up your account.
            </div>
          </div>

          <button
            onClick={() => navigate("/auth/login")}
            className="flex items-center gap-1 text-primary rounded-[4px] font-semibold text-[14px] "
          >
            Sign in
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
      {defLoading ? (
        <div className="mt-3">
          <Spinner />
        </div>
      ) : isAccessible ? (
        <div className="grid grid-cols-[auto_30%] gap-10 border-t">
          <div className="space-y-6 p-4">
            <div>
              <div className="font-bold text-[16px]">Basic Information</div>
              <div className="mt-4 space-y-4">
                <div className="grid grid-cols-2 gap-4 items-center">
                  <NormalInputField
                    title="First name"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setFirstname(e.target.value)}
                    value={firstname}
                  />

                  <NormalInputField
                    title="Last name"
                    type="text"
                    isRequired={true}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                  <NormalInputField
                    title="Prefix"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setPrefix(e.target.value)}
                  />

                  <NormalSelectInputField
                    title="Gender"
                    values={["Male", "Female", "Rather not say"]}
                    isRequired={true}
                    onChange={(e) => setGender(e.target.value)}
                  />
                  <NormalInputField
                    title="D.O.B"
                    isRequired={true}
                    type="date"
                    onChange={(e) => setDob(e.target.value)}
                  />

                  {/* <NormalInputField
                  title="Tax ID"
                  type="text"
                  isRequired={true}
                  onChange={(e) => setTaxId(e.target.value)}
                /> */}
                  <NormalInputField
                    title="Degree"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setDegree(e.target.value)}
                  />

                  <NormalInputField
                    title="Specialization"
                    type="text"
                    isRequired={true}
                    onChange={(e) => setSpecialization(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div>
              <div className="font-bold text-[16px]">Contact Details</div>
              <div className="mt-4 space-y-4">
                <div className="grid grid-cols-2 gap-4 items-center">
                  <NormalInputField
                    title="Address Line 1"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setAddress1(e.target.value)}
                  />

                  <NormalInputField
                    title="Address Line 2"
                    type="text"
                    onChange={(e) => setAddress2(e.target.value)}
                  />
                  <NormalInputField
                    title="Home Phone"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setHomePhone(e.target.value)}
                  />

                  <NormalInputField
                    title="Work Phone"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setWorkPhone(e.target.value)}
                  />
                  <NormalSelectInputField
                    title="Country"
                    isRequired={true}
                    values={countries.map((country) => country.name)}
                    onChange={(e) => setCountry(e.target.value)}
                  />

                  <NormalSelectInputField
                    title="State"
                    isRequired={true}
                    values={getStates()}
                    onChange={(e) => setState(e.target.value)}
                  />
                  <NormalInputField
                    title="City"
                    isRequired={true}
                    type="text"
                    onChange={(e) => setCity(e.target.value)}
                  />

                  <NormalInputField
                    title="Zipcode"
                    type="text"
                    isRequired={true}
                    onChange={(e) => setZipcode(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="py-1"></div>
          </div>

          <div className="border-l p-4 space-y-6">
            {/* <div>
              <div className="font-bold text-[16px]">License Information</div>

              <div className="mt-4 space-y-4">
                <NormalInputField
                  title="License Number"
                  type="text"
                  onChange={(e) => setLicenseNumber(e.target.value)}
                />
                <DEAInput
                  title="DEA Number"
                  value={deaNumber}
                  onChange={(e) => setDeaNumber(e.target.value)}
                />
                <NPIInput
                  title="NPI Number"
                  value={npiNumber}
                  onChange={(e) => setNpiNumber(e.target.value)}
                />
              </div>
            </div> */}

            <div>
              <div className="font-bold text-[16px]">Signature</div>

              <div className="mt-4">
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  canvasProps={{
                    className:
                      "sigCanvas w-full sm:w-full mb-1 h-[160px] border border-gray-300 rounded-[4px]",
                  }}
                />

                <button
                  onClick={clearSignature}
                  className="bg-primary py-1 px-2 font-medium text-white rounded-[2px] text-[12px]"
                >
                  Clear Signature
                </button>
              </div>
            </div>

            <div>
              <div className="font-bold text-[16px]">Account Information</div>

              <div className="mt-4 space-y-4">
                <NormalInputField
                  title="Login Email"
                  isRequired={true}
                  type="email"
                  disabled={facility?.email}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <PasswordField
                  title="Create Password"
                  type="password"
                  isRequired={true}
                  onChange={(e) => setPassword(e.target.value)}
                  width="full"
                />

                <AuthButton
                  title="Create Account"
                  disabled={isButtonNotActive || isLoading}
                  onClick={handleRegister}
                  isLoading={isLoading}
                  width="w-full"
                />

                <div className="font-semibold text-red-500">{errorMessage}</div>
                  <AgreementConsent />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="px-4 mt-4 h-96">
          <span className="text-sm">
            URL token provided is expired or invalid. Reachout to the Pharmacy
            whom invited you to send a new invite link
          </span>
        </div>
      )}
    </div>
  );
}
